"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notes = function Notes() {
	return _react2.default.createElement(
		"g",
		{ id: "Notes" },
		_react2.default.createElement("path", { d: "M450,0H50C22.5,0,0.2,22.5,0.2,50L0,500l100-100h350c27.5,0,50-22.5,50-50V50C500,22.5,477.5,0,450,0z M150,300h-50v-50h50 V300z M150,225h-50v-50h50V225z M150,150h-50v-50h50V150z M325,300H200v-50h125V300z M400,225H200v-50h200V225z M400,150H200v-50 h200V150z" })
	);
};

exports.default = Notes;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Notes.js
// module id = 2970
// module chunks = 4